import Module from '@/views/common/module/Module'
import Index from '@/views/common/Index'
import Home from '@/views/exhibition/home/Home'
import Exhprediction from '@/views/exhibition/prediction/exhprediction/Exhprediction'
import ExhpredictionApprove from '@/views/exhibition/prediction/exhprediction/ExhpredictionApprove'
import Exhibitor from '@/views/exhibition/prediction/exhibitor/Exhibitor'
import VenueTrader from '@/views/exhibition/venue/trader/Trader'
import Position from '@/views/exhibition/booth/position/Position'
import PositionDesign from '@/views/exhibition/booth/design/PositionDesign'
import PositionSelect from '@/views/exhibition/booth/select/PositionSelect'
import PositionType from '@/views/exhibition/booth/type/PositionType'
import StatisProduct from '@/views/statistical/exhibition/product/StatisProduct'
import StatisArea from '@/views/statistical/exhibition/area/StatisArea'
import StatisConfirm from '@/views/statistical/exhibition/confirm/StatisConfirm'
import RegistrationStatis from '@/views/statistical/exhibition/RegistrationStatis'
import BoothLog from '@/views/exhibition/log/booth/BoothLog'
import SmsLog from '@/views/exhibition/log/sms/SmsLog'
import LoginLog from '@/views/exhibition/log/login/LoginLog'
import BoothDesignLog from '@/views/exhibition/log/booth/BoothDesignLog'
import BoothPayLog from '@/views/exhibition/log/booth/BoothPayLog'
import BoothSelectLog from '@/views/exhibition/log/booth/BoothSelectLog'
import BoothTimeLog from '@/views/exhibition/log/booth/BoothTimeLog'
import Time from '@/views/exhibition/booth/time/Time'
import Manage from '@/views/contract/manage/Manage'
import Backup from '@/views/contract/backup/Backup'
import Set from '@/views/contract/set/Set'
import Classify from '@/views/contract/classify/Classify'
import BoothStatis from '@/views/statistical/booth/BoothStatis'
import StatisNoBooth from '@/views/statistical/exhibition/booth/StatisNoBooth'
import ContractStatis from '@/views/statistical/contract/ContractStatis'
// 参展人员
import ParticipantsBaseinfo from '@/views/exhibition/prediction/participants/Baseinfo'
import ParticipantsManage from '@/views/exhibition/prediction/participants/Manage'
// 参展人员数量
import Number from '@/views/exhibition/prediction/number/Baseinfo'
import NumberManage from '@/views/exhibition/prediction/number/Manage'
// 企业信用等级管理
import gradeList from '@/views/exhibition/prediction/industry/gradeList'
// 会员单位
import unitsList from '@/views/exhibition/prediction/member/unitsList'
// 理事单位
import membersList from '@/views/exhibition/prediction/council/membersList'
//展团单位
import exhibitionGroup from '@/views/exhibition/prediction/exhibitionGroup/index'
// 黑名单
import blacklist from '@/views/exhibition/prediction/blacklist/index'
// 摇号设置
import drawLots from '@/views/drawLots/drawLotsSetting'
// 摇号
import lottery from '@/views/lottery/index'
import lotteries from '@/views/lottery/lotteries'
//摇号结果查询
import drawLotsRecord from '@/views/drawLots/drawLotsRecord'
//展商信息审批
import Approval from '@/views/exhibition/prediction/Approval/Approval'
// 审批批语管理
import commentary from '@/views/exhibition/prediction/Approval/commentary'
// 档位面积管理
import GearList from '@/views/exhibition/prediction/GearList/index'
// 展商档位划分
import Division from '@/views/exhibition/prediction/GearList/Division'
import PositionStatistical from '@/views/exhibition/booth/statistical/PositionStatistical'
//付款管理
import Payment from '@/views/financial/payment/Payment'
//延期付款
import DeferredPayment from '@/views/financial/deferredPayment/DeferredPayment'
//合同统计分析
import ContractStatistical from '@/views/contract/statistical/Statistical'
//单位情况统计分析
import ApplicationStatistical from '@/views/exhibition/prediction/applicationStatistical/ApplicationStatistical'
import Messageboard from '@/views/messageboard/Messageboard'
import BootTypeChange from '@/views/bootTypeChange/BootTypeChange'
import Publication from '@/views/publication/Publication'
import ExhibitionConfirmation from '@/views/exhibitorsUpload/Confirmation'
import Safety from '@/views/exhibitorsUpload/Safety'
import Designated from '@/views/exhibition/booth/designated/Designated'


export default [
  {
    path: '/module',
    meta: {auth: true},
    component: Module,
    children: [
      {
        path: '/',
        name: 'module',
        component: resolve => require(['@/views/common/module/ModuleList'], resolve)
      }
    ]
  },
  //----------摇号----------
  {
    path: '/lottery',
    meta: {auth: true, title: "摇号", isRedirect: true},
    component: lottery,
    children: [
      {
        path: '/',
        name: 'lottery',
        meta: {keepAlive: false},
        component: resolve => require(['@/views/lottery/index'], resolve)
      }
    ]
  },
  {
    path: '/lotteries',
    meta: {auth: true, title: "摇号", isRedirect: true},
    component: lotteries,
    children: [
      {
        path: '/',
        name: 'lotteries',
        meta: {keepAlive: false},
        component: resolve => require(['@/views/lottery/lotteries'], resolve)
      }
    ]
  },
  {
    path: '/index',
    name: 'index',
    redirect: 'home',
    meta: {auth: true},
    component: Index,
    children: [
      //----------原首页----------
      // {
      //   path: '/home',
      //   meta: {auth: true, title: "首页"},
      //   component: Home,
      //   children: [
      //     {
      //       path: '/',
      //       name: 'home',
      //       component: resolve => require(['@/views/exhibition/home/homeList'], resolve)
      //     }
      //   ]
      // },
      //----------首页----------
      {
        path: '/home',
        meta: {auth: true, title: "首页",isRedirect: true},
        component: Home,
        children: [
          {
            path: '/',
            name: 'home',
            component: resolve => require(['@/views/exhibition/home/home_PC.vue'], resolve)
          },
          {
            path: '/home/boothStatisVenueList',
            name: 'home/boothStatisVenueList',
            meta: {auth: true, title: "按展馆统计企业列表", keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/position/PositionAnalysis'], resolve)
          },
        ]
      },
      //----------展会报名管理----------
      {
        path: '/prediction/exhprediction',
        meta: {auth: true, title: "展会报名管理", isRedirect: true},
        component: Exhprediction,
        children: [
          {
            path: '/',
            name: 'exhprediction',
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionList'], resolve)
          },
          {
            path: '/prediction/exhprediction/detail',
            name: 'exhpredictionDetail',
            meta: {auth: true, title: "展会报名管理详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
          {
            path: '/prediction/exhprediction/insert',
            name: 'exhpredictionInsert',
            meta: {auth: true, title: "展会报名管理新增", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionEdit'], resolve)
          },
          {
            path: '/prediction/exhprediction/update',
            name: 'exhpredictionUpdate',
            meta: {auth: true, title: "展会报名管理编辑", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionEdit'], resolve)
          },
          {
            path: '/prediction/exhprediction/insert_ENG',
            name: 'exhpredictionInsert_ENG',
            meta: {auth: true, title: "展会报名管理新增", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionEdit_ENG'], resolve)
          },
          {
            path: '/prediction/exhprediction/update_ENG',
            name: 'exhpredictionUpdate_ENG',
            meta: {auth: true, title: "展会报名管理编辑", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionEdit_ENG'], resolve)
          },
        ]
      },
      //----------展会报名审核----------
      {
        path: '/prediction/exhprediction_approve',
        meta: {auth: true, title: "展会报名审核", isRedirect: true},
        component: ExhpredictionApprove,
        children: [
          {
            path: '/',
            name: 'exhpredictionApprove',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionApproveList'], resolve)
          },
          {
            path: '/prediction/exhprediction_approve/detail',
            name: 'exhpredictionApproveDetail',
            meta: {auth: true, title: "展会报名审核详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
          {
            path: '/prediction/exhprediction_approve/approve',
            name: 'prediction/exhprediction_approve/approve',
            meta: {auth: true, title: "审核", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
        ]
      },

      //----------参展人员申报----------
      {
        path: '/participants/participants_baseinfo',
        meta: {auth: true, title: "参展商证申报", isRedirect: true},
        component: ParticipantsBaseinfo,
        children: [
          {
            path: '/',
            name: 'participantsBaseinfo',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/participants/BaseinfoList'], resolve)
          }
        ]
      },
      //----------参展人员管理----------
      {
        path: '/participants/participants_manage',
        meta: {auth: true, title: "参展商证管理", isRedirect: true},
        component: ParticipantsManage,
        children: [
          {
            path: '/',
            name: 'participantsManage',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/participants/ManageList'], resolve)
          }
        ]
      },
      //----------参展人员数量申报----------
      {
        path: '/number/number_baseinfo',
        meta: {auth: true, title: "参展商证数量申报", isRedirect: true},
        component: Number,
        children: [
          {
            path: '/',
            name: 'numberBaseinfo',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/number/BaseinfoList'], resolve)
          }
        ]
      },
      //----------参展人员数量管理----------
      {
        path: '/number/number_manage',
        meta: {auth: true, title: "参展商证数量管理", isRedirect: true},
        component: NumberManage,
        children: [
          {
            path: '/',
            name: 'numberManage',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/number/ManageList'], resolve)
          }
        ]
      },
      //----------展商用户管理----------
      {
        path: '/prediction/exhibitor',
        meta: {auth: true, title: "展商用户管理", isRedirect: true},
        component: Exhibitor,
        children: [
          {
            path: '/',
            name: 'exhibitor',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhibitor/ExhibitorList'], resolve)
          },
          {
            path: '/prediction/exhprediction/detail',
            name: 'exhhibitorDetail',
            meta: {auth: true, title: "展会报名信息详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
        ]
      },
      //----------展馆管理-展馆平面图----------
      {
        path: '/venue/plan',
        meta: {auth: true, title: "展馆平面图", isRedirect: true},
        component: VenueTrader,
        children: [
          {
            path: '/',
            name: 'venue/plan',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/venue/plan/Plan'], resolve),
          },
          {
            path: '/venue/plan/design',
            name: 'venue/plan/design',
            meta: {auth: true, title: "展位设计", keepAlive: false},
            component: resolve => require(['@/views/exhibition/ploter/Plot'], resolve),
          },
        ]
      },
      //----------展馆管理-展馆管理----------
      {
        path: '/venue/trader',
        meta: {auth: true, title: "展馆管理"},
        component: VenueTrader,
        children: [
          {
            path: '/',
            name: 'trader',
            component: resolve => require(['@/views/exhibition/venue/trader/TraderList'], resolve)
          },
        ]
      },
      //----------展位管理-展位管理----------
      {
        path: '/booth/position',
        meta: {auth: true, title: "展位管理", isRedirect: true},
        component: Position,
        children: [
          {
            path: '/',
            name: 'position',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/position/PositionList'], resolve)
          },
          {
            path: '/booth/position/detail',
            name: 'booth/position/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
          {
            path: '/booth/position/analysis',
            name: 'positionAnalysis',
            meta: {auth: true, title: "展位分析", keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/position/PositionAnalysis'], resolve)
          },
        ]
      },

      //----------展位管理-展位选择----------
      {
        path: '/booth/select',
        meta: {auth: true, title: "展位选择"},
        component: PositionSelect,
        children: [
          {
            path: '/',
            name: 'positionSelect',
            component: resolve => require(['@/views/exhibition/booth/select/PositionSelect'], resolve)
          },
        ]
      },
      //----------展位管理-展位设计----------
      {
        path: '/booth/positionDesign',
        meta: {auth: true, title: "展位设计"},
        component: PositionDesign,
        children: [
          {
            path: '/',
            name: 'positionDesign',
            //component: resolve => require(['@/views/booth/design/PositionDesign'], resolve)
            component: resolve => require(['@/views/exhibition/ploter/Plot'], resolve),
            props: true
          }
        ]
      },
      //----------展位管理-展位分类----------
      {
        path: '/booth/positionType',
        meta: {auth: true, title: "展位分类"},
        component: PositionType,
        children: [
          {
            path: '/',
            name: 'positionType',
            component: resolve => require(['@/views/exhibition/booth/type/PositionTypeList'], resolve)
          },
        ]
      },
      //----------展位管理-展位选择统计----------
      {
        path: '/booth/positionStatistical',
        meta: {auth: true, title: "展位选择情况",isRedirect: true},
        component: PositionStatistical,
        children: [
          {
            path: '/',
            name: 'booth/positionStatistical',
            component: resolve => require(['@/views/exhibition/booth/statistical/PositionStatisticalList'], resolve)
          },
          {
            path: '/booth/positionStatistical/list',
            name: 'booth/positionStatistical/list',
            meta: {auth: true, title: "展位列表", keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/statistical/PositionStatisticalDetail'], resolve)
          },
          {
            path: '/booth/positionStatistical/detail',
            name: 'booth/positionStatistical/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
          {
            path: '/booth/positionStatistical/analysis',
            name: 'positionAnalysis',
            meta: {auth: true, title: "展位选择情况", keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/position/PositionAnalysis'], resolve)
          },
          {
            path: '/booth/positionStatistica/positionDesign',
            name: 'booth/positionStatistica/positionDesign',
            meta: {auth: true, title: "展位设计", keepAlive: false},
            component: resolve => require(['@/views/exhibition/ploter/Plot'], resolve),
            props: true
          }
        ]
      },
      //-----展位选择确认------
      {
        path: '/booth/positionAnalysis',
        meta: {auth: true, title: "展位选择确认",isRedirect: true},
        component: Position,
        children: [
          {
            path: '/',
            name: 'booth/positionAnalysis',
            component: resolve => require(['@/views/exhibition/booth/position/PositionAnalysis'], resolve)
          },
          
        ]
      },
      //----------展位管理 E2展馆展商管理----------

      {
        path: '/booth/designatedE2',
        meta: {auth: true, title: "E2展商管理",isRedirect: true},
        component: Designated,
        children: [
          {
            path: '/',
            name: 'booth/designatedE2',
            component: resolve => require(['@/views/exhibition/booth/designated/DesignatedList'], resolve)
          },
          
        ]
      },

      //----------统计分析-按产品类型统计----------
      {
        path: '/statistical/statisProduct',
        meta: {auth: true, title: "按产品类型统计", isRedirect: true},
        component: StatisProduct,
        children: [
          {
            path: '/',
            name: 'statisProduct',
            component: resolve => require(['@/views/statistical/exhibition/product/StatisProductEcharts'], resolve)
          },
        /*  {
            path: '/statistical/statisProductList',
            name: 'statislProductList',
            meta: {auth: true, title: "按产品类型统计企业列表"},
            component: resolve => require(['@/views/statistical/exhibition/product/StatisProAreaList'], resolve)
          },
          {
            path: '/statistical/statisProductQyDetail',
            name: 'statistical/statisProductQyDetail',
            meta: {auth: true, title: "企业详情"},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },*/
        ]
      },
      //----------已审核无展位统计----------

      {
        path: '/statistical/statisNoBooth',
        meta: {auth: true, title: "已审核无展位展商统计", isRedirect: true},
        component: StatisNoBooth,
        children: [
          {
            path: '/',
            name: 'statisNoBooth',
            component: resolve => require(['@/views/statistical/exhibition/booth/StatisNoBooth'], resolve)
          }
        ]
      },
      //----------统计分析-按光地展位面积统计----------
      {
        path: '/statistical/statisArea',
        meta: {auth: true, title: "按光地展位面积统计", isRedirect: true},
        component: StatisArea,
        children: [
          {
            path: '/',
            name: 'statisArea',
            component: resolve => require(['@/views/statistical/exhibition/area/StatisAreaEcharts'], resolve)
          },
      /*    {
            path: '/statistical/statisAreaList',
            name: 'statisAreaList',
            meta: {auth: true, title: "按光地展位面积统计企业列表"},
            component: resolve => require(['@/views/statistical/exhibition/product/StatisProAreaList'], resolve)
          },
          {
            path: '/statistical/statisAreaQyDetail',
            name: 'statistical/statisAreaQyDetail',
            meta: {auth: true, title: "企业详情"},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },*/
        ]
      },
      //----------统计分析-按确认信息统计----------
      {
        path: '/statistical/statisConfirm',
        meta: {auth: true, title: "按确认信息统计", isRedirect: true},
        component: StatisConfirm,
        children: [
          {
            path: '/',
            name: 'statisConfirm',
            component: resolve => require(['@/views/statistical/exhibition/confirm/StatisConfirmEcharts'], resolve)
          },
      /*    {
            path: '/statistical/statisConfirmList',
            name: 'statisConfirmList',
            meta: {auth: true, title: "按确认信息统计企业列表"},
            component: resolve => require(['@/views/statistical/exhibition/confirm/StatisConfirmList'], resolve)
          },
          {
            path: '/statistical/statisConfirmQyDetail',
            name: 'statistical/statisConfirmQyDetail',
            meta: {auth: true, title: "企业详情"},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },*/
        ]
      },
      //----------统计分析-报名统计分析----------
      {
        path: '/statistical/registrationStatis',
        meta: {auth: true, title: "报名统计分析", isRedirect: true},
        component: RegistrationStatis,
        children: [
          {
            path: '/',
            name: 'registrationStatis',
            component: resolve => require(['@/views/statistical/exhibition/RegistrationStatisList'], resolve)
          },
          {
            path: '/statistical/statisConfirmList',
            name: 'statisConfirmList',
            meta: {auth: true, title: "按确认信息统计企业列表"},
            component: resolve => require(['@/views/statistical/exhibition/confirm/StatisConfirmList'], resolve)
          },
          {
            path: '/statistical/statisConfirmQyDetail',
            name: 'statistical/statisConfirmQyDetail',
            meta: {auth: true, title: "企业详情"},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
          {
            path: '/statistical/statisAreaList',
            name: 'statisAreaList',
            meta: {auth: true, title: "按光地展位面积统计企业列表"},
            component: resolve => require(['@/views/statistical/exhibition/product/StatisProAreaList'], resolve)
          },
          {
            path: '/statistical/statisAreaQyDetail',
            name: 'statistical/statisAreaQyDetail',
            meta: {auth: true, title: "企业详情"},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
          {
            path: '/statistical/statisProductList',
            name: 'statislProductList',
            meta: {auth: true, title: "按产品类型统计企业列表"},
            component: resolve => require(['@/views/statistical/exhibition/product/StatisProAreaList'], resolve)
          },
          {
            path: '/statistical/statisProductQyDetail',
            name: 'statistical/statisProductQyDetail',
            meta: {auth: true, title: "企业详情"},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
        ]
      },
      //----------统计分析-展位选择统计----------
      {
        path: '/statistical/boothStatis',
        meta: {auth: true, title: "展位选择统计", isRedirect: true},
        component: BoothStatis,
        children: [
          {
            path: '/',
            name: 'boothStatis',
            component: resolve => require(['@/views/statistical/booth/BoothStatisList'], resolve)
          },
          {
            path: '/statistical/boothStatisVenueList',
            name: 'boothStatisVenueList',
            meta: {auth: true, title: "按展馆统计企业列表", keepAlive: false},
            component: resolve => require(['@/views/exhibition/booth/position/PositionAnalysis'], resolve)
          },
          {
            path: '/statistical/boothStatisProList',
            name: 'boothStatisProList',
            meta: {auth: true, title: "按产品类型统计企业列表"},
            component: resolve => require(['@/views/statistical/booth/product/BoothStatisProList'], resolve)
          },
          {
            path: '/statistical/boothStatisAreaList',
            name: 'boothAreaList',
            meta: {auth: true, title: "按地区统计企业列表"},
            component: resolve => require(['@/views/statistical/booth/area/BoothStatisAreaList'], resolve)
          },
          {
            path: '/statistical/boothStatisProDetail',
            name: 'statistical/boothStatisProDetail',
            meta: {auth: true, title: "企业详情"},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
        ]
      },
      //----------统计分析-展位选择统计----------
      {
        path: '/statistical/contractStatis',
        meta: {auth: true, title: "合同执行情况统计", isRedirect: true},
        component: ContractStatis,
        children: [
          {
            path: '/',
            name: 'statistical/contractStatis',
            component: resolve => require(['@/views/statistical/contract/ContractStatisList'], resolve)
          }
        ]
      },
      //----------日志管理-展位日志----------
      {
        path: '/log/boothLog',
        meta: {auth: true, title: "展位日志"},
        component: BoothLog,
        children: [
          {
            path: '/',
            name: 'boothLog',
            component: resolve => require(['@/views/exhibition/log/booth/BoothLogList'], resolve)
          },
        ]
      },
      //----------日志管理-展位绘制日志----------
      {
        path: '/log/boothDesignLog',
        meta: {auth: true, title: "展位绘制日志", isRedirect: true},
        component: BoothDesignLog,
        children: [
          {
            path: '/',
            name: 'boothDesignLog',
            component: resolve => require(['@/views/exhibition/log/booth/BoothDesignLogList'], resolve)
          },
        ]
      },
      //----------日志管理-展位交款日志----------
      {
        path: '/log/boothPayLog',
        meta: {auth: true, title: "展位交款日志", isRedirect: true},
        component: BoothPayLog,
        children: [
          {
            path: '/',
            name: 'boothPayLog',
            component: resolve => require(['@/views/exhibition/log/booth/BoothPayLogList'], resolve)
          },
        ]
      },
      //----------日志管理-展位选择日志----------
      {
        path: '/log/boothSelectLog',
        meta: {auth: true, title: "展位选择日志", isRedirect: true},
        component: BoothSelectLog,
        children: [
          {
            path: '/',
            name: 'boothSelectLog',
            component: resolve => require(['@/views/exhibition/log/booth/BoothSelectLogList'], resolve)
          },
        ]
      },
      //----------日志管理-展位选择时间日志----------
      {
        path: '/log/boothTimeLog',
        meta: {auth: true, title: "展位选择时间日志", isRedirect: true},
        component: BoothTimeLog,
        children: [
          {
            path: '/',
            name: 'boothTimeLog',
            component: resolve => require(['@/views/exhibition/log/booth/BoothTimeLogList'], resolve)
          },
        ]
      },
      //----------日志管理-短信日志----------
      {
        path: '/log/smsLog',
        meta: {auth: true, title: "短信日志"},
        component: SmsLog,
        children: [
          {
            path: '/',
            name: 'smsLog',
            component: resolve => require(['@/views/exhibition/log/sms/SmsLogList'], resolve)
          },
        ]
      },
      //----------日志管理-登录日志----------
      {
        path: '/log/loginLog',
        meta: {auth: true, title: "登录日志"},
        component: LoginLog,
        children: [
          {
            path: '/',
            name: 'log/loginLog',
            component: resolve => require(['@/views/exhibition/log/login/LoginLogList'], resolve)
          },
        ]
      },
      //-------------------------------------------------------展位选择时间设置--------------------------------------------------
      {
        path: '/booth/time',
        meta: {
          auth: true,
          title: "展位选择时间设置",
          isRedirect: true
        },
        component: Time,
        children: [{
            path: '/',
            name: 'sj',
            component: resolve => require(['@/views/exhibition/booth/time/TimeList'], resolve)
          },
        ]
      },

      //----------合同设置----------
      {
        path: '/contract/set',
        meta: {auth: true, title: "展位合同设置", isRedirect: true},
        component: Set,
        children: [
          {
            path: '/',
            name: 'setList',
            component: resolve => require(['@/views/contract/set/SetList'], resolve)
          },
          {
            path: '/contract/htsz/insert',
            name: 'setInsert',
            meta: {auth: true, title: "展位合同设置新增"},
            component: resolve => require(['@/views/contract/set/SetEdit'], resolve)
          },
          {
            path: '/contract/htsz/update',
            name: 'setUpdate',
            meta: {auth: true, title: "展位合同设置编辑"},
            component: resolve => require(['@/views/contract/set/SetEdit'], resolve)
          },
        ]
      },

      //----------合同归档----------
      {
        path: '/contract/classify',
        meta: {auth: true, title: "展位合同归档", isRedirect: true},
        component: Set,
        children: [
          {
            path: '/',
            name: 'classifyList',
            component: resolve => require(['@/views/contract/classify/ClassifyList'], resolve)
          },
          {
            path: '/contract/classify/detail',
            name: 'classify/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          },
        ]
      },

        //----------合同管理----------
      {
        path: '/contract/manage',
        meta: {auth: true, title: "合同管理", isRedirect: true},
        component: Manage,
        children: [
          {
            path: '/',
            name: 'manageList',
            component: resolve => require(['@/views/contract/manage/ManageList'], resolve)
          },
          {
            path: '/contract/manage/update',
            name: 'manageUpdate',
            meta: {auth: true, title: "合同管理编辑"},
            component: resolve => require(['@/views/contract/manage/ManageEdit'], resolve)
          },
          {
            path: '/contract/manage/detail',
            name: 'manage/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          }
        ]
      },
      // ----------合同审批----------
      {
        path: '/contract/manage/process',
        meta: {auth: true, title: "合同审批", isRedirect: true},
        component: Manage,
        children: [
          {
            path: '/',
            name: 'contract/manage/process',
            component: resolve => require(['@/views/contract/manage/ManageSH'], resolve)
          },
          {
            path: '/contract/manage/process/detail',
            name: 'contract/manage/process/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          }
        ]
      },
      // 展商合同管理
      {
        path: '/contract/manage/ManageZS',
        name: 'ManageZS',
        meta: {auth: true, title: "展商合同管理"},
        component: resolve => require(['@/views/contract/manage/ManageZS'], resolve)
      },
      //----------合同备案----------
      {
        path: '/contract/backup',
        meta: {auth: true, title: "展位合同备案", isRedirect: true},
        component: Backup,
        children: [
          {
            path: '/',
            name: 'backupList',
            component: resolve => require(['@/views/contract/backup/BackupList'], resolve)
          },
          {
            path: '/contract/backup/detail',
            name: 'backup/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          }
        ]
      },
      //----------合同统计分析----------
      {
        path: '/contract/statistical',
        meta: {auth: true, title: "合同签订情况", isRedirect: true},
        component: ContractStatistical,
        children: [
          {
            path: '/',
            name: 'contract/statistical',
            component: resolve => require(['@/views/contract/statistical/ContractStatistical'], resolve)
          },
        ]
      },
      //----------企业信用等级管理----------
      {
        path: '/industry/gradeList',
        meta: {auth: true, title: "企业信用等级", isRedirect: true},
        component: gradeList,
        children: [
          {
            path: '/',
            name: 'industryGradeList',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/industry/gradeList'], resolve)
          }
        ]
      },
      //----------会员单位管理----------
      {
        path: '/member/unitsList',
        meta: {auth: true, title: "会员单位管理", isRedirect: true},
        component: unitsList,
        children: [
          {
            path: '/',
            name: 'memberUnitsList',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/member/unitsList'], resolve)
          }
        ]
      },
      //----------理事单位管理----------
      {
        path: '/council/membersList',
        meta: {auth: true, title: "理事单位管理", isRedirect: true},
        component: membersList,
        children: [
          {
            path: '/',
            name: 'councilMembersList',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/council/membersList'], resolve)
          }
        ]
      },
      //----------展团单位管理----------
      {
        path: '/exhibitionGroup',
        meta: {auth: true, title: "展团单位管理", isRedirect: true},
        component: exhibitionGroup,
        children: [
          {
            path: '/',
            name: 'exhibitionGroup',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhibitionGroup/index'], resolve)
          }
        ]
      },
      //----------黑名单管理----------
      {
        path: '/blacklist',
        meta: {auth: true, title: "黑名单管理", isRedirect: true},
        component: blacklist,
        children: [
          {
            path: '/',
            name: 'blacklist',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/blacklist/index'], resolve)
          }
        ]
      },
      //----------单位情况统计分析----------
      {
        path: '/applicationStatistical',
        meta: {auth: true, title: "已报名单位情况统计", isRedirect: true},
        component: ApplicationStatistical,
        children: [
          {
            path: '/',
            name: 'applicationStatistical',
            component: resolve => require(['@/views/exhibition/prediction/applicationStatistical/ApplicationStatisticalList'], resolve)
          },
          {
            path: '/applicationStatistical/detail',
            name: 'applicationStatistical/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          }
        ]
      },
      //----------摇号设置----------
      {
        path: '/drawLots/drawLotsSetting',
        meta: {auth: true, title: "摇号设置", isRedirect: true},
        component: drawLots,
        children: [
          {
            path: '/',
            name: 'drawLots',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/drawLots/drawLotsSetting'], resolve)
          }
        ]
      },
      //摇号结果查询
      {
        path: '/drawLots/drawLotsRecord',
        meta: {auth: true, title: "摇号结果查询", isRedirect: true},
        component: drawLotsRecord,
        children: [
          {
            path: '/',
            name: 'drawLots/drawLotsRecord',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/drawLots/drawLotsRecord'], resolve)
          }
        ]
      },
      //账户变更审核
      {
        path: '/exhibitor/approval',
        meta: {auth: true, title: "账户变更审核", isRedirect: true},
        component: Approval,
        children: [
          {
            path: '/',
            name: 'exhibitor/approval',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/Approval/Approval'], resolve)
          }
        ]
      },
      // 批语管理
      {
        path: '/exhibitor/commentary',
        meta: {auth: true, title: "审批批语管理", isRedirect: true},
        component: commentary,
        children: [
          {
            path: '/',
            name: 'exhibitor/commentary',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/Approval/commentary'], resolve)
          }
        ]
      },
      // 档位面积管理
      {
        path: '/booth/GearList',
        meta: {auth: true, title: "档位面积管理", isRedirect: true},
        component: GearList,
        children: [
          {
            path: '/',
            name: 'booth/GearList',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/GearList/index'], resolve)
          }
        ]
      },
      // 档位划分
      {
        path: '/booth/GearList/division',
        meta: {auth: true, title: "展商报名情况统计", isRedirect: true},
        component: Division,
        children: [
          {
            path: '/',
            name: 'booth/GearList/division',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/GearList/DivisionTree'], resolve)
          },
          {
            path: '/booth/GearList/divisionList',
            name: 'booth/GearList/divisionList',
            meta: {auth: true, title: "展商档位划分详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/GearList/divisionList'], resolve)
          },
          {
            path: '/booth/GearList/registrationDivisionList',
            name: 'booth/GearList/registrationDivisionList',
            meta: {auth: true, title: "已报名档位面积需求详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/GearList/RegistrationDivisionList'], resolve)
          },
        ]
      },
      //财务管理----付款管理
      {
        path: '/financial/payment',
        meta: {auth: true, title: "付款管理", isRedirect: true},
        component: Payment,
        children: [
          {
            path: '/',
            name: 'financial/payment',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/financial/payment/PaymentList'], resolve)
          },
          {
            path: '/financial/payment/detail',
            name: 'financial/payment/detail',
            meta: {auth: true, title: "企业详情", keepAlive: false},
            component: resolve => require(['@/views/exhibition/prediction/exhprediction/ExhpredictionDetail'], resolve)
          }
        ]
      },

      //----------延期付款----------
      {
        path: '/financial/deferredPayment',
        meta: {auth: true, title: "延期付款", isRedirect: true},
        component: DeferredPayment,
        children: [
          {
            path: '/',
            name: 'deferredPayment',
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentList'], resolve)
          },
          {
            path: '/financial/deferredPayment/add',
            name: 'financial/deferredPayment/add',
            meta: {auth: true, title: "新增"},
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentEdit'], resolve)
          },
          {
            path: '/financial/deferredPayment/edit',
            name: 'financial/deferredPayment/edit',
            meta: {auth: true, title: "编辑"},
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentEdit'], resolve)
          },
          {
            path: '/financial/deferredPayment/detail',
            name: 'financial/deferredPayment/detail',
            meta: {auth: true, title: "详情", keepAlive: false},
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentDetail'], resolve)
          }
        ]
      },
      //----------延期付款审批----------
      {
        path: '/financial/deferredPaymentApprove',
        meta: {auth: true, title: "延期付款审批", isRedirect: true},
        component: DeferredPayment,
        children: [
          {
            path: '/',
            name: 'deferredPaymentApprove',
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentApproveList'], resolve)
          },
          {
            path: '/financial/deferredPaymentApprove/add',
            name: 'financial/deferredPaymentApprove/add',
            meta: {auth: true, title: "新增"},
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentApproveEdit'], resolve)
          },
          {
            path: '/financial/deferredPaymentApprove/edit',
            name: 'financial/deferredPaymentApprove/edit',
            meta: {auth: true, title: "编辑"},
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentApproveEdit'], resolve)
          },
          {
            path: '/financial/deferredPaymentApprove/detail',
            name: 'financial/deferredPaymentApprove/detail',
            meta: {auth: true, title: "详情", keepAlive: false},
            component: resolve => require(['@/views/financial/deferredPayment/DeferredPaymentDetail'], resolve)
          }
        ]
      },
      
      //财务管理----付款情况统计
      {
        path: '/financial/paymentStatics',
        meta: {auth: true, title: "付款情况统计", isRedirect: true},
        component: Payment,
        children: [
          {
            path: '/',
            name: 'financial/paymentStatics',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/financial/payment/PaymentStatis'], resolve)
          },
          {
            path: '/financial/paymentStatics/htDetail',
            name: 'financial/paymentStatics/htDetail',
            meta: {auth: true, title: "合同详情", keepAlive: false},
            component: resolve => require(['@/views/contract/manage/ManageList'], resolve)
          },
          {
            path: '/financial/paymentStatics/jfDetail',
            name: 'financial/paymentStatics/jfDetail',
            meta: {auth: true, title: "缴费详情", keepAlive: false},
            component: resolve => require(['@/views/financial/payment/PaymentList'], resolve)
          }
        ]
      },

      //----------留言板信息发布----------
      {
        path: '/messageboard',
        meta: {auth: true, title: "信息发布", isRedirect: true},
        component: Messageboard,
        children: [
          {
            path: '/',
            name: 'messageboard',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/messageboard/MessageboardList.vue'], resolve)
          }
        ]
      },
      //----------标改特----------
      {
        path: '/bootTypeChange',
        meta: {auth: true, title: "标改特", isRedirect: true},
        component: BootTypeChange,
        children: [
          {
            path: '/',
            name: 'bootTypeChange',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/bootTypeChange/BootTypeChangeList.vue'], resolve)
          }
        ]
      },
      //----------会刊管理---------
      {
        path: '/publication',
        meta: {auth: true, title: "会刊管理", isRedirect: true},
        component: Publication,
        children: [
          {
            path: '/',
            name: 'publication',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/publication/PublicationList.vue'], resolve)
          }
        ]
      },
      //参展确认书
      {
        path: '/exhibitionConfirmation',
        meta: {auth: true, title: "参展确认书", isRedirect: true},
        component: ExhibitionConfirmation,
        children: [
          {
            path: '/',
            name: 'exhibitionConfirmation',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibitorsUpload/ConfirmationList'], resolve)
          }
        ]
      },
      //安全确认书
      {
        path: '/safetyConfirmation',
        meta: {auth: true, title: "安全确认书", isRedirect: true},
        component: Safety,
        children: [
          {
            path: '/',
            name: 'safetyConfirmation',
            meta: {keepAlive: false},
            component: resolve => require(['@/views/exhibitorsUpload/SafetyList'], resolve)
          }
        ]
      },
      
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/exhibition.js